"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetIndexerUnfinalisedPlans = exports.GetIndexerClosedFlexPlans = exports.GetIndexerOngoingFlexPlans = exports.GetConsumerClosedFlexPlans = exports.GetConsumerOngoingFlexPlans = exports.GetStateChannels = exports.GetPaygPlans = exports.StateChannelFields = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.StateChannelFields = (0, graphql_tag_1.default) `
  fragment StateChannelFields on StateChannel {
    id
    indexer
    consumer
    status
    total
    spent
    price
    isFinal
    expiredAt
    terminatedAt
    deployment {
      id
      project {
        id
        metadata
      }
    }
    terminateByIndexer
  }
`;
exports.GetPaygPlans = (0, graphql_tag_1.default) `
  query GetPaygPlans($indexer: String!, $deploymentId: String!, $status: ChannelStatus!) {
    stateChannels(
      filter: {
        indexer: { equalTo: $indexer }
        status: { equalTo: $status }
        deploymentId: { equalTo: $deploymentId }
      }
    ) {
      totalCount
      nodes {
        ...StateChannelFields
      }
    }
  }
  ${exports.StateChannelFields}
`;
exports.GetStateChannels = (0, graphql_tag_1.default) `
  query GetStateChannels($status: ChannelStatus!) {
    stateChannels(filter: { status: { equalTo: $status } }) {
      totalCount
      nodes {
        ...StateChannelFields
      }
    }
  }
  ${exports.StateChannelFields}
`;
exports.GetConsumerOngoingFlexPlans = (0, graphql_tag_1.default) `
  query GetConsumerOngoingFlexPlans($consumer: String!, $now: Datetime!, $offset: Int) {
    stateChannels(
      filter: {
        consumer: { equalTo: $consumer }
        status: { equalTo: OPEN }
        expiredAt: { greaterThan: $now }
      }
      offset: $offset
    ) {
      totalCount
      nodes {
        ...StateChannelFields
      }
    }
  }
  ${exports.StateChannelFields}
`;
exports.GetConsumerClosedFlexPlans = (0, graphql_tag_1.default) `
  query GetConsumerClosedFlexPlans($consumer: String!, $now: Datetime!, $offset: Int) {
    stateChannels(
      filter: {
        consumer: { equalTo: $consumer }
        or: [{ status: { equalTo: FINALIZED } }, { expiredAt: { lessThan: $now } }]
      }
      offset: $offset
    ) {
      totalCount
      nodes {
        ...StateChannelFields
      }
    }
  }
  ${exports.StateChannelFields}
`;
exports.GetIndexerOngoingFlexPlans = (0, graphql_tag_1.default) `
  query GetIndexerOngoingFlexPlans(
    $indexer: String!
    $deploymentId: String!
    $now: Datetime!
    $offset: Int
  ) {
    stateChannels(
      filter: {
        indexer: { equalTo: $indexer }
        status: { equalTo: OPEN }
        expiredAt: { greaterThan: $now }
        deploymentId: { equalTo: $deploymentId }
      }
      offset: $offset
    ) {
      totalCount
      nodes {
        ...StateChannelFields
      }
    }
  }
  ${exports.StateChannelFields}
`;
exports.GetIndexerClosedFlexPlans = (0, graphql_tag_1.default) `
  query GetIndexerClosedFlexPlans(
    $indexer: String!
    $deploymentId: String!
    $now: Datetime!
    $offset: Int
  ) {
    stateChannels(
      filter: {
        indexer: { equalTo: $indexer }
        deploymentId: { equalTo: $deploymentId }
        or: [{ status: { equalTo: FINALIZED } }, { expiredAt: { lessThan: $now } }]
      }
      offset: $offset
    ) {
      totalCount
      nodes {
        ...StateChannelFields
      }
    }
  }
  ${exports.StateChannelFields}
`;
exports.GetIndexerUnfinalisedPlans = (0, graphql_tag_1.default) `
  query GetIndexerUnfinalisedPlans($indexer: String!, $now: Datetime!) {
    stateChannels(
      filter: {
        indexer: { equalTo: $indexer }
        status: { notEqualTo: FINALIZED }
        expiredAt: { lessThan: $now }
      }
    ) {
      totalCount
      nodes {
        ...StateChannelFields
      }
    }
  }
  ${exports.StateChannelFields}
`;
//# sourceMappingURL=statechannel.generated.js.map